import React from "react";
import { Link } from "react-router-dom";
import './Home.css';

// Import images
import frontendDevelopmentImg from '../images/frontend-development.jpg';
import javascriptLibrariesImg from '../images/javascript-libraries.jpg';
import careerPathImg from '../images/career-path.jpg';

const Home = () => {
  const posts = [
    { id: 1, title: 'Introduction to Frontend Development', imageUrl: frontendDevelopmentImg },
    { id: 2, title: 'Exploring JavaScript Libraries and Frameworks', imageUrl: javascriptLibrariesImg },
    { id: 3, title: 'Career Path of a Frontend Developer', imageUrl: careerPathImg },
  ];

  return (
    <div className="home">
      <h2>Latest Blog Posts</h2>
      <div className="post-list">
        {posts.map(post => (
          <div key={post.id} className="post-card">
            <img src={post.imageUrl} alt={post.title} />
            <div className="post-content">
              <h3>{post.title}</h3>
              <p>{post.summary}</p>
              <Link to={`/post/${post.id}`} className="read-more">Read More</Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Home;
